import { render, staticRenderFns } from "./productOnShelfComponent.vue?vue&type=template&id=428bbbc0&scoped=true&"
import script from "./productOnShelfComponent.vue?vue&type=script&lang=js&"
export * from "./productOnShelfComponent.vue?vue&type=script&lang=js&"
import style0 from "./productOnShelfComponent.vue?vue&type=style&index=0&id=428bbbc0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428bbbc0",
  null
  
)

export default component.exports